import { Controller } from 'stimulus';

const dateFromTimeString = (timeString) => {
  const date = new Date();
  const [hour, minutes] = timeString.split(':');

  date.setHours(parseInt(hour, 10));
  date.setMinutes(parseInt(minutes, 10));
  date.setSeconds(0);

  return date;
};

class ContactOptionController extends Controller {
  connect() {
    if (this.timeBasedTarget) {
      this.startTimeBased();
    }
  }

  disconnect() {
    if (this.timeBasedInterval) {
      clearInterval(this.timeBasedInterval);
    }
  }

  startTimeBased() {
    this.timeBasedInterval = setInterval(this.timeBasedIntervalHandler.bind(this), 10000);
    this.timeBasedIntervalHandler();
  }

  timeBasedIntervalHandler() {
    const time = this.timeBasedTarget.getAttribute('data-online').split('-');
    const [startTime, endTime] = time;
    const now = new Date();

    const isOpen = (
      dateFromTimeString(startTime).getTime() < now.getTime()
      && dateFromTimeString(endTime).getTime() > now.getTime()
    );

    this.indicatorTarget.style.display = isOpen ? 'block' : 'none';
  }
}

ContactOptionController.targets = [
  'timeBased',
  'indicator',
];

export default ContactOptionController;
